var SiteWide = function() {};

SiteWide.prototype.init = function() {
	this.windowResizeTimer = '';
	this.bindEvents();
	this.initSearchModalAccessibility();
	this.initDisclosureModalAccessibility();
	this.nextFocusableElement = null;
};

SiteWide.prototype.bindEvents = function() {
	$('body').on(
		'click',
		'.page-disclosure-link',
		$.proxy(this.handleDisclosureClick, this)
	);

	$('body').on(
		'special-resize', // this is defined in /Scripts/resize-event.js
		$.proxy(this.handleResize, this)
	);

	$('body').on(
		'keydown',
		'.nav-tabs a, .nav.nav-main a',
		$.proxy(this.handleNavKeydown, this)
	);

	// Accessibility concerns for the two event bindings below
	$('body').on(
		'shown.bs.modal',
		function () {
			$('main.container').attr('aria-hidden', 'true');
		}
	);

	$('body').on(
		'hidden.bs.modal',
		function () {
			$('main.container').attr('aria-hidden', 'false');
		}
	);

	$('#modal-expense, #modal-extended-rating, #modal-inverse-leverage, #modal-returns, #modal-risk').on(
	'shown.bs.modal',
	$.proxy(this.handleShownModal, this)

	);

	//create the popover for warning icon and help button
	$(document).ajaxComplete(function () {
		$(document).find('.wells-popover').popover({
			html: true,
			content: function () {
				return $($(this).data('popover-content')).html();
			},
			trigger: 'manual',
			container: 'body'
		});
	});

	//WF-2357
	$(document).on('click', '.popover-trigger', $.proxy(function (e) {
			e.stopPropagation();

			var popoverTarget = $(e.currentTarget).attr('data-popover-target');

			if (!popoverTarget) {
				console.warn('Your popover trigger is missing the popover-target data attribute.');
				return false;
			};

			if ($(e.currentTarget).is('span')) {
				$(e.currentTarget).removeClass(':active');
				$(e.currentTarget).closest('a').addClass(':active');
				$(e.currentTarget).closest('a').trigger('click');
			}
			else if ($(e.currentTarget).is('a')) {
				$(e.currentTarget).popover('hide');
				$(e.currentTarget).popover('toggle');
				this.selectPopover(e);
				this.customizePopover(e);
			}
			
		}, this)
	);

	$(document).on('keydown', '.popover-trigger, .popover-close', $.proxy(this.handleNavKeydown, this));   

	$(document).on('keydown', '.popover-close', $.proxy(function (e) {
		
		if (e.which !== 9 || e.which === 27 || (e.keyCode === 9 && e.shiftKey)) return;

		event.preventDefault(); // prevent scrolling
		event.target.click(); // execute regular click event on the link

	}, this));   

	$(document).on('keydown', '.popover-content', $.proxy(function (e) {

		if (e.keyCode === 9 && e.shiftKey) {
						
			e.preventDefault();
			var cancel = $($(e.currentTarget).parent()).children('a.popover-close');

			if (cancel) {
				cancel.click();
			}
		}
	}, this));  

	$(document).on('click', '.popover-close', $.proxy(function (e) {
		
			e.stopPropagation();
			var popoverTarget = $(e.currentTarget).attr('data-popover-target');

			if (!popoverTarget) {
				console.warn('Your popover trigger is missing the popover-target data attribute.');
				return false;
			};

			$(document).find(popoverTarget).popover('hide');
			//[WF-2876] - select previous element after clos popover
			this.nextFocusableElement.focus();

		}, this)
	);

	//WF-2356 : close popover on ESC key event
	$(document).on('keydown', $.proxy(function (e) {

		if (e.keyCode == 27) {
			//WF-2530 Close tooltips upon escape key event
			var instance = $('body').data('mk-tooltip');

			$('.mk-tooltip-trigger').each(function (index, element) {
				instance.hide(element);
			});

			if ($(document).find('.popover:visible').length > 0) {
				$(document).find('.wells-popover').popover('hide');
			}

			if ($(event.currentTarget) && $(event.currentTarget).find('.popover-close')) {	
				event.stopPropagation();
				this.closePopover($(event.currentTarget).find('.popover-close'));
			}
		}
		else if ($(e.currentTarget.activeElement).hasClass('popover-content') && (e.keyCode === 9 && e.shiftKey)) {

			if ($(document).find('.popover:visible').length > 0) {
				$(document).find('.wells-popover').popover('hide');
			}

			if ($(event.currentTarget) && $(event.currentTarget).find('.popover-close')) {	
				event.stopPropagation();
				$(event.currentTarget).find('.popover-close').click();
			}
		}

		}, this)
	);

	$(window).on("orientationchange", $.proxy(this.handleOrientationChange, this));

};

SiteWide.prototype.handleDisclosureClick = function(evt) {
	evt.preventDefault();
	var disclosureType = $(evt.target).closest('a').data('disclosuretype');

	if (disclosureType === 'news') {
		return MOD.WfEasyXdm.sendMessage({ 'DISC': 'modnews' });
	}

	// Marktes
	if (disclosureType === 'market') {
		return MOD.WfEasyXdm.sendMessage({'DISC': 'modmarket'});
	}

	if (disclosureType === 'news') {
		return MOD.WfEasyXdm.sendMessage({'DISC': 'modnews'});
	}

	if (disclosureType === 'research') {
		return MOD.WfEasyXdm.sendMessage({'DISC': 'modresearch'});
	}

	// ETF & Screeners
	if (disclosureType === 'holdings') {
		return MOD.WfEasyXdm.sendMessage({ 'DISC': 'modholdingsallocation' });
	}

	if (disclosureType === 'risk') {
		return MOD.WfEasyXdm.sendMessage({ 'DISC': 'modrisketf' });
	}

	if (disclosureType === 'inversed') {
		return MOD.WfEasyXdm.sendMessage({ 'DISC': 'modinverseleveragedetf' });
	}

	if (disclosureType === 'smartbeta') {
		return MOD.WfEasyXdm.sendMessage({ 'DISC': 'modsmartbeta' });
    }

    // Mutual Funds
    if (disclosureType === 'expense') {
		return MOD.WfEasyXdm.sendMessage({ 'DISC': 'MODEXPENSE' });
    }

    if (disclosureType === 'mstar') {
		return MOD.WfEasyXdm.sendMessage({ 'DISC': 'MODMSTAR' });
    }

    if (disclosureType === 'mf') {
		return MOD.WfEasyXdm.sendMessage({ 'DISC': 'MODMF' });
    }

    if (disclosureType === 'returns') {
		return MOD.WfEasyXdm.sendMessage({ 'DISC': 'MODRETURNS' });
    }

    if (disclosureType === 'mfrisk') {
		return MOD.WfEasyXdm.sendMessage({ 'DISC': 'MODRISK' });
    }

    if (disclosureType === 'chart') {
	  return MOD.WfEasyXdm.sendMessage({ 'PDF': 'https://www.wellsfargoadvisors.com/bw/disclosures/MFI-disclosures.pdf' });
    }

	return false;
};

//
// event handling for iOS device rotation > hide popover
//
SiteWide.prototype.handleOrientationChange = function () {

	$(document).find('.wells-popover').popover('hide');

	return;
};

SiteWide.prototype.handleResize = function() {
	clearTimeout(this.windowResizeTimer);
	this.windowResizeTimer = window.setTimeout(
		function() {
			MOD.WfEasyXdm.sendWindowSize();
		},
		100
	);
};

//
// need to be able to 'click' on the tabs with space or enter
//	- JAWS accessibility issue
//
SiteWide.prototype.handleNavKeydown = function (event) {	
    if (event.which === 32 || event.which === 13) {
        if (event.target.className.indexOf("mk-dp-control") === -1) { // exclude mk datepicker controls - this causes them to fire twice
            event.preventDefault(); // prevent scrolling
            event.target.click(); // execute regular click event on the link
        }						
	}
};

//[WF-2876] - select popuper
SiteWide.prototype.selectPopover = function (event) {	
	var focusables = $(":focusable");
	var index = focusables.index(document.activeElement);
	var trigger = $(event.target);

	if (trigger) {
		this.nextFocusableElement = trigger.is("a") ? trigger : trigger.closest("a");
	}
	else {
		this.nextFocusableElement = focusables.eq(index + 1);
	}

	var popover = $('.popover-content');
	popover.attr('tabindex', 0);
	popover.focus();
};

SiteWide.prototype.customizePopover = function(event) {	
    var $origin = $(event.target);
    var ctrlIdentifier = $origin.attr('cancel-control');
    var $ctrl = $('#' + ctrlIdentifier);

    if (!$origin || !$ctrl) {
		return;
	}

    if ($ctrl && $origin.attr('text-aria-label')) {
        $ctrl.attr('aria-label', $origin.attr('text-aria-label'));
	}
}

SiteWide.prototype.closePopover = function(closePopover) {
	var popoverTarget = $(closePopover).attr('data-popover-target');

	if (!popoverTarget) {
		console.warn('Your popover trigger is missing the popover-target data attribute.');
		return false;
	};

	$(popoverTarget).find(popoverTarget).popover('hide');
	//[WF-2876] - select previous element after clos popover
	this.nextFocusableElement.focus();
}

//
// [WF-2090] - need special handling to prevent user from tabbing outside of #search-modal
//
SiteWide.prototype.initSearchModalAccessibility = function () {
	var $searchModal = $('#search-modal');

	// modal keydown event
	$searchModal.on('keydown', $.proxy(this.handleModalKeydownEvent, this));

	$searchModal.on('shown.bs.modal', function () {
		$searchModal.find('.close-modal').focus();
	});

	// modal hidden event
	$searchModal.on('hidden.bs.modal', function () {

		// WF-2305
		// - attribute is added by InteractiveChartApp_Class.js
		// this will only be true if the modal was opened by .change-symbol-button
		var isChangeSymbolLink = $searchModal.attr('data-is-change-symbol-button') === 'true';

		// WF-2305
		// focus on .change-symbol-button if it was triggered by that link in the first place
		if (isChangeSymbolLink) {

			$('.change-symbol-button-container .change-symbol-button').focus();
			$searchModal.removeAttr('data-is-change-symbol-button');
		}
	});
};

SiteWide.prototype.initDisclosureModalAccessibility = function () {
	var $disclosureModal = $('#modal-expense, #modal-extended-rating, #modal-inverse-leverage, #modal-returns, #modal-risk');

	// modal keydown event
	$disclosureModal.on('keydown', $.proxy(this.handleDisclosureModalKeydownEvent, this));

	$disclosureModal.on('shown.bs.modal', function () {
		$disclosureModal.find('.close-modal').focus();
	});
};

SiteWide.prototype.handleDisclosureModalKeydownEvent = function (evt) {
	if (evt.keyCode == 32) {
		$(evt.currentTarget).find('a.close-modal').click();
	}

	// Check for tab keycode
	if (evt.keyCode != 9) {
		return;
	}

	if (evt.keyCode === 9 && evt.shiftKey) {
		handleBackDisclosureModalTab(evt);
	}

	if (evt.keyCode === 9 && !evt.shiftKey) {
		handleForwardDisclosureModalTab(evt);
	}
};

function handleForwardDisclosureModalTab(evt) {
	if ($(evt.target).hasClass('disclosure-close-link-end')) {
		returnToDisclosureCloseIcon(evt);
	}
};

function handleBackDisclosureModalTab(evt) {
	if ($(evt.target).hasClass('close-modal')) {
		returnToDisclosureCloseLink(evt);
	}
};

function returnToDisclosureCloseIcon(evt) {
	evt.preventDefault();
	$(evt.target).closest('#modal-expense, #modal-extended-rating, #modal-inverse-leverage, #modal-returns, #modal-risk').find('.close-modal').focus();
};

function returnToDisclosureCloseLink(evt) {
	evt.preventDefault();
	$(evt.target).closest('#modal-expense, #modal-extended-rating, #modal-inverse-leverage, #modal-returns, #modal-risk').find('.disclosure-close-link-end').focus();
};

SiteWide.prototype.handleModalKeydownEvent = function (evt) {
	// Check for tab keycode
	if (evt.keyCode != 9) {
		return;
	}
	// something to pass along to utilities to let them know if there are tabbable .search-links
	var hasResults = $('#popup-results-container').find('.search-link').length > 0;

	if (evt.keyCode === 9 && evt.shiftKey) {
		handleModalBackwardTab(evt, hasResults);
	}

	if (evt.keyCode === 9 && !evt.shiftKey) {
		handleModalFowardTab(evt, hasResults);
	}
};

//
// [WF-2376] > Utility method to handle whether or not the "Go" button is enabled in the pagination partial
//
SiteWide.prototype.handleGoButton = function (evt) {

	var $target = $(evt.target);
	var $goButton = $target.closest('nav').find('.go-button');

	// no need to do anything if the "Go" button is enabled
	if (!$goButton.hasClass('disabled')) {
		return;
	}

	var totalPages = parseInt($target.siblings('.all-pages').text(), 10);
	var originalValue = parseInt($target.attr('value'), 10);
	var newValue = $target.val() !== ""
		? parseInt($target.val(), 10)
		: "";

	if (isNaN(newValue)) {
		$target.val("");
		return;
	}

	if (originalValue !== newValue && newValue !== "" && totalPages > 1) {
		$goButton.removeClass('disabled');
		$goButton.attr('aria-disabled', 'false');
	}
};

SiteWide.prototype.handleShownModal = function (evt) {
	evt.preventDefault();
	$(evt.target).find('.icon-close').closest('.link-icon').focus();
};

//
// utility for initModalAccessibility
//
function handleModalFowardTab(evt, hasResults) {
	if ($(evt.target).attr('id') === 'popup-search-button' && !hasResults) {
		returnToCloseIcon(evt);
	}

	if ($(evt.target).hasClass('search-link') && hasResults) {
		// if our current focused target is the last .search-link in the popup results container, focus on the close icon
		//	- comparing DOM elements
		var isLast = $(evt.target)[0] === $('#popup-results-container').find('.search-link').last()[0];

		if (isLast) {
			returnToCloseIcon(evt);
		}
	}
};

//
// utility for initModalAccessibility
//
function returnToCloseIcon(evt) {
	evt.preventDefault();
	$(evt.target).closest('#search-modal').find('.close-modal').focus();
};

//
// utility for initModalAccessibility
//
function handleModalBackwardTab(evt, hasResults) {
	if ($(evt.target).hasClass('close-modal') && !hasResults) {
		evt.preventDefault();
		$('#popup-search-button').focus();
	}

	if ($(evt.target).hasClass('close-modal') && hasResults) {
		evt.preventDefault();
		$('#popup-results-container').find('.search-link').last().focus();
	}
};
